import { fetcher } from "@website/fetcher/fetcher/fetcher";
import { RefreshTokenResponse } from "@website/fetcher/refresh-token/types";
import { getToken, logout, saveLogin } from "@website/hooks/auth-manager";
import { isChannel } from "@website/utils/channel/helpers";
import { FORCE_LOGIN_KEY } from "@website/widget/login/constants";
import { ReadonlyURLSearchParams } from "next/navigation";
import { NextRouter } from "next/router";

const baseURLProfile = `${
  process.env.NEXT_PUBLIC_BASE_URL_PLATFORM ||
  "https://platform-api.asiatech.ptp"
}/profile`;

let refreshTokenPromise: Promise<void> | null = null;

export const refreshToken = () => {
  if (refreshTokenPromise) return refreshTokenPromise;

  const { refreshToken: _refreshToken } = getToken();
  if (!_refreshToken) {
    logout();
    return Promise.reject("refresh token missing");
  }
  refreshTokenPromise = fetcher<RefreshTokenResponse>({
    url: `${baseURLProfile}/auth/refresh-token`,
    method: "POST",
    data: { refreshToken: _refreshToken }
  })
    .then(({ data }) => {
      saveLogin(data);
    })
    .catch((error) => {
      logout();
      throw error;
    })
    .finally(() => {
      refreshTokenPromise = null;
    });

  return refreshTokenPromise;
};
export const forceLogin = async (forceLoginParameter: unknown) => {
  if (isChannel(["b2b"])) {
    if (typeof window !== "undefined") window.location.href = "/b2b-login";
  } else {
    const isFlight = Boolean(process.env.NEXT_PUBLIC_APP_NAME_TICKET);
    return new Promise((resolve, reject) => {
      if (isFlight) {
        const { searchParameters, router } = forceLoginParameter as {
          searchParameters: ReadonlyURLSearchParams;
          router: { replace: (url: string) => void };
        };
        const currentParameters = new URLSearchParams(searchParameters);
        currentParameters.set("login_step", "phone-number");
        currentParameters.set(FORCE_LOGIN_KEY, "true");
        router.replace(`?${currentParameters.toString()}`);
      } else {
        const router = forceLoginParameter as NextRouter;
        router.replace(
          {
            query: {
              ...router.query,
              login_step: "phone-number",
              [FORCE_LOGIN_KEY]: true
            }
          },
          undefined,
          {
            scroll: false,
            shallow: true
          }
        );
      }
      document.addEventListener("onLoginModalEnd", resolve);
      document.addEventListener("onLoginModalClose", reject);
    });
  }
};
